
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class ReceiptMaterialItemsDialog extends _Ext.EditorDialogBase<ReceiptMaterialItemsRow> {
        protected getFormKey() { return ReceiptMaterialItemsForm.formKey; }
        protected getIdProperty() { return ReceiptMaterialItemsRow.idProperty; }
        protected getLocalTextPrefix() { return ReceiptMaterialItemsRow.localTextPrefix; }
        protected getNameProperty() { return ReceiptMaterialItemsRow.nameProperty; }
        protected getService() { return ReceiptMaterialItemsService.baseUrl; }
        protected getDeletePermission() { return ReceiptMaterialItemsRow.deletePermission; }
        protected getInsertPermission() { return ReceiptMaterialItemsRow.insertPermission; }
        protected getUpdatePermission() { return ReceiptMaterialItemsRow.updatePermission; }

        protected form = new ReceiptMaterialItemsForm(this.idPrefix);

    }
}